import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import { useField, useFormikContext } from "formik";
import { AddSolutionFormValues } from "../../add/form/types";
import { EditSolutionFormValues } from "../../edit/form/types";
import {
  NotReadyForSaleReason,
  SELECTABLE_NOT_READY_FOR_SALE_REASONS,
} from "../../types";

export const NOT_READY_FOR_SALE_REASON_FIELD =
  "solution-not-ready-for-sale-reason";

function NotReadyForSaleReasonSelect() {
  const { values } = useFormikContext<
    AddSolutionFormValues | EditSolutionFormValues
  >();
  const [field, meta, helpers] = useField<NotReadyForSaleReason | null>(
    NOT_READY_FOR_SALE_REASON_FIELD,
  );

  const isReadyForSale = values["solution-is-ready-for-sale"];
  const hasValidationMessage = Boolean(meta.error);
  const selectedReason = field.value ?? "";
  const isSelectedReasonUnlisted =
    selectedReason !== "" &&
    !SELECTABLE_NOT_READY_FOR_SALE_REASONS.some(
      (reason) => reason === selectedReason,
    );

  const handleChange = (event: SelectChangeEvent<NotReadyForSaleReason | "">) =>
    helpers.setValue(
      event.target.value === ""
        ? null
        : (event.target.value as NotReadyForSaleReason),
    );

  return (
    <FormControl
      fullWidth
      variant="standard"
      disabled={isReadyForSale}
      error={hasValidationMessage}
    >
      <InputLabel id="solution-not-ready-for-sale-reason-label">
        Reason
      </InputLabel>

      <Select
        id="solution-not-ready-for-sale-reason"
        labelId="solution-not-ready-for-sale-reason-label"
        name={NOT_READY_FOR_SALE_REASON_FIELD}
        variant="standard"
        label="Reason"
        value={selectedReason}
        onChange={handleChange}
      >
        {isSelectedReasonUnlisted && (
          <MenuItem sx={{ display: "none" }} value={selectedReason}>
            {selectedReason}
          </MenuItem>
        )}
        {SELECTABLE_NOT_READY_FOR_SALE_REASONS.map((reason) => (
          <MenuItem key={reason} value={reason}>
            {reason}
          </MenuItem>
        ))}
      </Select>

      {hasValidationMessage && <FormHelperText>{meta.error}</FormHelperText>}
    </FormControl>
  );
}

export default NotReadyForSaleReasonSelect;
